<template>
  <v-slide-y-transition mode="out-in">
    <v-container class="fluid pt-0">
      <v-card dark>
        <v-img
          :src="require('@/assets/img/bg/forest.jpg')"
          gradient="to top, rgba(0,0,0,.44), rgba(0,0,0,.44)"
          aspect-ratio="5.95"
        >
          <v-container fill-height>
            <v-layout align-center>
              <strong class="display-4 font-weight-regular mr-4">{{$moment().format('D')}}</strong>
              <v-layout column justify-end>
                <div class="headline font-weight-light">{{$moment().format('dddd')}}</div>
                <div class="text-uppercase font-weight-light">{{$moment().format('MMMM YYYY')}}</div>
              </v-layout>
            </v-layout>
          </v-container>
        </v-img>
      </v-card>
      <v-timeline align-top>
        <v-timeline-item
          v-for="(item, i) in items"
          :key="i"
          :color="item.color"
          :icon="item.icon"
         
        >
          <template slot="opposite">
            <span class="headline" :class="item.color+'--text'">{{item.area}}</span>
          </template>
          <v-card class="mt-0 pt-0" :color="item.color" dark>
            <v-card-title class="title pt-1 pb-1">{{item.title}} &nbsp; 
              <router-link :to="{path:item.path}">
                <v-btn small class="mx-0" outline>
                  Explore
                </v-btn>
              </router-link>              
            </v-card-title>
            <v-card-text class="white text--primary pb-1">
              <p>{{item.desc}}</p>              
            </v-card-text>
          </v-card>
        </v-timeline-item>
      </v-timeline>
    </v-container>  
  </v-slide-y-transition>  
</template>
<script>
export default {
  components: {
    
  },
  data: () => ({
    items: [
      {
        area : 'TPS',
        title: 'Report C1',
        desc : 'pleno perhitungan per TPS',
        color: 'teal',
        path : '/report/c1',
        icon: 'mdi-star'
      },
      {
        area : 'Kelurahan',
        title: 'Report D1',
        desc : 'pleno tingkat kelurahan dengan menyediakan data sampai ke TPS',
        color: 'purple',
        path : '/report/d1',
        icon: 'mdi-book-variant'
      },
      {
        area : 'Kecamatan',
        title: 'Report DA1',
        desc : 'pleno tingkat kecamatan dengan menyediakan data sampai kelurahan',
        color: 'green',
        path : '/report/da1',
        icon: 'mdi-airballoon'
      },
      {
        area : 'Kota/Kabupaten',
        title: 'Report DB1',
        desc : 'pleno tingkat kabupaten/kota dengan menyediakan data sampai kecamatan',
        color: 'lime',
        path : '/report/db1',
        icon: 'mdi-buffer'
      },
      {
        area : 'Provinsi',
        title: 'Report DC1',
        desc : 'pleno tingkat provinsi dengan menyediakan data sampai kabupaten/kota',
        color: 'cyan',
        path : '/report/dc1',
        icon: 'mdi-buffer'
      }
    ]
  }),
  computed: {
    
    
  },
};
</script>

